<template>
  <label for="services-multiselect-component" class="form-label">
    {{ $t('service.name') }}
  </label>
  <TomSelect
    v-model="componentValue.selectedService"
    :options="{
      create: false,
      placeholder: $t('service.select')
    }"
    class="w-full"
  >
    <option
      v-for="service in services"
      :value="service.uuid"
      :key="service.uuid"
    >
      {{ service.name.sk_SK }}
    </option>
  </TomSelect>
</template>

<script>
import { defineComponent, computed } from 'vue'
import serviceApi from '../../services/services/service.api'

export default defineComponent({
  data() {
    return {
      services: []
    }
  },
  mounted() {
    serviceApi.getList(1, 1000).then(
      response => {
        this.services = response.data.data
        if (response.data.data.length > 0) {
          this.$emit('update:selectedService', {
            selectedService: response.data.data[0].uuid
          })
        }
      },
      error => {
        alert(error)
      }
    )
  },
  props: {
    selectedService: {
      type: Object,
      default: () => {}
    },
    employee: {
      type: String,
      default: () => null
    }
  },

  emits: ['update:selectedService'],

  setup(props, { emit }) {
    const componentValue = computed({
      get: () => props.selectedService,
      set: value => emit('update:selectedService', value)
    })

    return {
      componentValue
    }
  }
})
</script>
